import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Guscio } from "./componenti/Guscio";
import { ConSchede } from "./componenti/Schede";
import { AttivaSecondoFattore } from "./pagine/AttivaSecondoFattore";
import { CambiaPassword } from "./pagine/CambiaPassword";
import { Entra } from "./pagine/Entra";
import { INDIRIZZI_VECCHI, primaSezione, sezioniPer } from "./sezioni";
import { ProvveditoreSessione, useSessione } from "./sessione";

function Smistamento() {
  const { utente } = useSessione();

  // Non lo so ancora: la prima risposta del server non e' arrivata. Mostrare
  // qui la pagina di accesso la farebbe lampeggiare a chi e' gia' dentro.
  if (utente === undefined) {
    return <p className="attesa">Un momento.</p>;
  }

  if (utente === null) {
    return <Entra />;
  }

  // La password provvisoria la conoscono in due. Finche' non cambia non si
  // vede nient'altro: e' l'unica schermata raggiungibile, senza nemmeno il
  // menu. Il backend non lo impone (le rotte rispondono lo stesso), quindi
  // questo e' un cancello di comodo e non una difesa. Vale comunque: quasi
  // nessuno aggira una porta chiusa che non aveva intenzione di aprire.
  if (utente.deve_cambiare_password) {
    return <CambiaPassword obbligato />;
  }

  // Dopo la password, la verifica in due passaggi: obbligatoria per tutti. Stesso
  // schema del cambio password: qui e' un cancello di comodo, il blocco vero e'
  // del server, che risponde 403 a ogni rotta di lavoro finche' non e' attiva.
  if (utente.deve_attivare_secondo_fattore) {
    return <AttivaSecondoFattore />;
  }

  // Solo le sezioni che quel ruolo puo' vedere diventano rotte. Un indirizzo
  // scritto a mano fuori da questo elenco non trova niente e cade sull'ultima
  // riga, che rimanda alla prima sezione utile.
  const sezioni = sezioniPer(utente.ruolo);

  return (
    <Routes>
      <Route element={<Guscio />}>
        {sezioni.map((sezione) =>
          sezione.schede ? (
            <Route
              key={sezione.percorso}
              path={sezione.percorso}
              element={
                <ConSchede titolo={sezione.nome} voci={sezione.schede} base={sezione.percorso} />
              }
            >
              <Route
                index
                element={<Navigate to={sezione.schede[0]?.percorso ?? "/"} replace />}
              />
              {sezione.schede.map((scheda) => (
                <Route key={scheda.percorso} path={scheda.percorso} element={scheda.elemento} />
              ))}
            </Route>
          ) : (
            // "/*": la pagina legge da se' il resto dell'indirizzo, come
            // Fatturare con le sue schede con i conteggi.
            <Route
              key={sezione.percorso}
              path={`${sezione.percorso}/*`}
              element={sezione.elemento}
            />
          ),
        )}
        {Object.entries(INDIRIZZI_VECCHI).map(([vecchio, nuovo]) => (
          <Route key={vecchio} path={vecchio} element={<Navigate to={nuovo} replace />} />
        ))}
        {/* Il cambio password sta fuori dalla mappa apposta: non e' una
            sezione di lavoro, non compare nel menu, e vale per chiunque sia
            entrato, qualunque ruolo abbia. */}
        <Route path="/password" element={<CambiaPassword />} />
        <Route
          path="*"
          element={<Navigate to={primaSezione(utente.ruolo)} replace />}
        />
      </Route>
    </Routes>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <ProvveditoreSessione>
        <Smistamento />
      </ProvveditoreSessione>
    </BrowserRouter>
  );
}
